/** @jsx jsx */

import { FormattedMessage } from 'react-intl';
import { Colors, Grid, Text } from '@zapier/design-system';
import { Icon } from '@zapier/zinnia-icons';
import { jsx } from '@emotion/core';

import Dismiss from 'app/developer-v3/components/Dismiss';
import Link from 'app/common/components/Link';

import Styles from '../CTAVersioning.styles';

type Props = {
  onDismiss: () => void;
  version: string;
};

function PromotionDone(props: Props) {
  const { onDismiss, version } = props;

  return (
    <div css={Styles.root(Colors.StatusSuccessWeakest)}>
      <Grid columns="30px auto 20px" gap={20}>
        <Icon color="StatusSuccess" name="formCheckCircle" size={30} />
        <div>
          <Text fontWeight={600} tag="h2" type="Body4">
            <FormattedMessage
              defaultMessage="Version {version} is promoted!"
              id="headings-version-promoted"
              values={{ version }}
            />
          </Text>
          <Text margin="10px 0px 0px" tag="p">
            <FormattedMessage
              defaultMessage="Your integration version has been successfully promoted. You can migrate users to this version now. If you notice any issues, <component0>contact us</component0>."
              id="messages-promotion-success-with-contact-support-link"
              values={{
                component0: chunks => (
                  <Link
                    href="https://developer.zapier.com/contact"
                    target="_blank"
                  >
                    {chunks}
                  </Link>
                ),
              }}
            />
          </Text>
        </div>
        <Dismiss onDismiss={onDismiss} />
      </Grid>
    </div>
  );
}

export default PromotionDone;
